import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { getActiveLocaleSelector, createModuleStateSelector, createConfigSelector } from '@americanexpress/travel-selectors';
import { isToggleEnabled } from '../helpers/helpers';
import { CLICK_TO_CHAT_ENABLED, EWP_BOOKING_SERVICE_TOGGLE } from '../constants/constants';
import {
  AXP_CLIENT_ONE_CMS_INTERNET_BASE_URL,
  AXP_CLIENT_BOOKING_SERVICE_API_URL,
  AXP_CLIENT_BACKEND_CANCEL_API_URL,
  ONE_CLIENT_HOME_API_URL,
  AXP_CLIENT_BENEFITS_BASE_URL,
  AXP_CLIENT_APIGEE_API_DOMAIN,
  AXP_CLIENT_EWP_API_DOMAIN,
  AXP_CLIENT_FAAS_API_DOMAIN,
  AXP_CLIENT_DATA_CONTROLLER_API,
  AXP_CLIENT_EWP_BOOKING_SERVICE_API_URL,
} from '../iguazu-rest/baseUrls';

export const getLangPackSelector = (state) => state.getIn(
  ['intl', 'languagePacks', getActiveLocaleSelector(state), 'axp-manage-bookings-root'],
  fromJS({})
).toJS();
export const getModuleStateSelector = createModuleStateSelector('axp-manage-bookings-root');
export const getIguazuResourcesSelector = createSelector(
  getModuleStateSelector,
  (state) => state.getIn(['resources'])
);
export const getOneLoginDomain = createConfigSelector('oneLoginDomain');
export const getAkamaiDomain = createConfigSelector('akamaiDomain');
export const getOneCmsApiUrl = createConfigSelector(AXP_CLIENT_ONE_CMS_INTERNET_BASE_URL);
const bookingServiceAPIUrl = createConfigSelector(AXP_CLIENT_BOOKING_SERVICE_API_URL);
const backendCancelApiUrl = createConfigSelector(AXP_CLIENT_BACKEND_CANCEL_API_URL);
export const getTravelHomeApiUrl = createConfigSelector(ONE_CLIENT_HOME_API_URL);
export const getBenefitsApiUrl = createConfigSelector(AXP_CLIENT_BENEFITS_BASE_URL);
export const getApigeeApiUrl = createConfigSelector(AXP_CLIENT_APIGEE_API_DOMAIN);
export const getEwpApiUrl = createConfigSelector(AXP_CLIENT_EWP_API_DOMAIN);
export const getFaasApiUrl = createConfigSelector(AXP_CLIENT_FAAS_API_DOMAIN);
export const getDataControllerApiUrl = createConfigSelector(AXP_CLIENT_DATA_CONTROLLER_API);

export const ewpBookingServiceApiUrl = createConfigSelector(AXP_CLIENT_EWP_BOOKING_SERVICE_API_URL);

export const getToggleSelector = (state) => state.getIn(
  ['modules', 'axp-manage-bookings-root', 'resources', 'toggleFeature', 'items'],
  fromJS({})
).toJS();

export const getClickToChat = (state) => !!isToggleEnabled(
  getToggleSelector(state), getActiveLocaleSelector(state), CLICK_TO_CHAT_ENABLED);

export const getBookingsServiceApiUrl = (state) => (
  isToggleEnabled(
    getToggleSelector(state), getActiveLocaleSelector(state), EWP_BOOKING_SERVICE_TOGGLE)
    ? ewpBookingServiceApiUrl(state) : bookingServiceAPIUrl(state));

export const getCancellationServiceApiUrl = (state) => backendCancelApiUrl(state);

export const getTripsApiUrl = createConfigSelector('tripsApiUrl');
export const getTripDetailsApiUrl = createConfigSelector('tripDetailsApiUrl');
export const getModificationsApiUrl = createConfigSelector('modificationsApiUrl');
